import { createGlobalStyle } from 'styled-components'
import { media, desktopMaxWidth } from 'utils/media'

export const BodyStyles = createGlobalStyle`
  body {
    background: var(--neutral-0);

    --light-yellow: #FFFBD6;

    --neutral-100: #111213;
    --neutral-80: #313335;
    --neutral-60: #656768;
    --neutral-40: #919395;
    --neutral-30: #C1C2C4;
    --neutral-20: #E4E4E5;
    --neutral-10: #F3F3F3;
    --neutral-5: #F9F9F9;
    --neutral-0: #fff;

    --green-80: #0C5A4B;
    --green-60: #3E8B54;
     
    --red-80: #BC143A;
    --red-60: #FF3865;

    --brand-dark-green: #0C5A4B;
    --brand-light-green: #C3FF8E;
    --brand-dark-blue: #2329AE;
    --brand-light-blue: #7EC6F8;
    --brand-red: #FF3865;
    --brand-purple: #CDA5FF;
    --brand-yellow: #FFF05C;
    --brand-orange: #FF895E;
    --brand-black: #000000;
    --brand-white: #FFFFFF;

    --box-padding: 40px;
    --wide-grid-spacing: 24px;
    --max-column-width: ${desktopMaxWidth}px;
    --max-column-without-spacing-width: calc(var(--max-column-width) - (var(--wide-grid-spacing) * 2));
    --max-width: 1224px;
    --header-height: 64px;
    --grid-gap-large: 24px;
    --grid-gap-small: 12px;
    --spacing: 24px;
    --border-width: 2px;
    --border: 1px solid black;
    --button-radius: 0px;
    --input-radius: 0px;

    --text-size-xxl: 64px;
    --line-height-xxl: 64px;
    ${media.phoneDown} {
      --text-size-xxl: 32px;
      --line-height-xxl: 40px;
    }

    --text-size-xl: 48px;
    --line-height-xl: 56px;
    ${media.phoneDown} {
      --text-size-xxl: 32px;
      --line-height-xxl: 40px;
    }

    --text-size-l: 36px;
    --line-height-l: 40px;
      
    --text-size-m: 24px;
    --line-height-m: 32px;

    --text-size-s: 20px;
    --line-height-s: 24px;

    --text-size-p: 18px;
    --line-height-p: 24px;

    --text-size-ps: 16px;
    --line-height-ps: 24px;
  
    --text-size-pxs: 14px;
    --line-height-pxs: 20px;
  
    --text-size-small: 12px;
    --line-height-small: 16px;

    --text-size-extra-small: 8px;
    --line-height-extra-small: 16px;

    ${media.tabletDown} {
      --box-padding: 20px;
      --spacing: 20px;
      --wide-grid-spacing: 16px;
    }
  }

  html {
    height: -webkit-fill-available;
  }

  *:focus:not(.focus-visible) {
    outline: none;
  }

  ::-moz-selection {
    color: var(--neutral-80);
    background: var(--light-yellow);
  }
  ::selection {
    color: var(--neutral-80);
    background: var(--light-yellow);
  }

`
